var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClearFilter32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.53 5.47a.75.75 0 00-1.06 0A3114.49 3114.49 0 016.397 24.554a.75.75 0 001.133.976l3.97-3.895.009 4.123c.034.35.17.683.391.959.629.78 1.772.906 2.557.283l3.994-3.3c.345-.33.55-.802.55-1.3L19 19.5l4.323-4.39a1.81 1.81 0 00.427-1.168V9.311l2.853-2.865a.75.75 0 00-.073-.976zm-4.28 5.34L13 20.136v5.447c0 .221.246.381.45.291l3.932-3.229a.312.312 0 00.11-.174l.008-3.595 4.658-4.713a.31.31 0 00.086-.159l.006-3.192zM19.008 7a.75.75 0 01.102 1.493L8.9 8.5c-.725 0-1.32.547-1.387 1.245L7.5 13.942a.31.31 0 00.092.22l2.715 2.414A.75.75 0 119.25 17.64l-2.715-2.413a1.81 1.81 0 01-.528-1.125V9.878A2.884 2.884 0 018.73 7.005L19.008 7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearFilter32);
export default __webpack_public_path__ + "static/media/icon-clear-filter-32.63a852d9.svg";
export { ForwardRef as ReactComponent };